// extracted by mini-css-extract-plugin
export default {"button":"TakePictureButton_button__3OgoH"};